import { Button, Modal } from "@mantine/core";
import { useCallback } from "react";
import { ModalFooter } from "../../../../mantine/components/ModalFooter/ModalFooter";
import type { MachineAccountConfiguration } from "../../../../utils/backend-types";

interface ReimportMachineAccountModalProps {
  machineAccount: MachineAccountConfiguration | null;
  onClose: () => void;
  onSubmit: (id: number) => void;
}

function ReimportMachineAccountModal({
  machineAccount,
  onClose,
  onSubmit
}: ReimportMachineAccountModalProps) {
  const handleSubmit = useCallback(() => {
    if (!machineAccount) {
      return;
    }

    onSubmit(machineAccount.id);
    onClose();
  }, [machineAccount, onClose, onSubmit]);

  return (
    <Modal
      className="ReimportMachineAccountModal"
      opened
      title="Machine Account Datei Re-Import"
      onClose={onClose}
    >
      <p>{`Sind Sie sicher, dass Sie alle Dateien des Machine Accounts '${machineAccount?.email}' mit dem Parametersatz '${machineAccount?.parameterSetName}' erneut importieren wollen?`}</p>
      <ModalFooter>
        <Button variant="default" onClick={onClose}>
          Abbrechen
        </Button>
        <Button color="secondary" onClick={handleSubmit}>
          Einsenden
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export { ReimportMachineAccountModal };
